<div class="content-with-filled-button">
    <h1 class="title" *ngIf="code_product!='999'">{{ copyService.copies.agreement_filter_title }}</h1>
    <p class="sub-title" *ngIf="code_product!='999'">{{ copyService.copies.agreement_filter_sub_title }}</p>
    <h1 class="title" *ngIf="code_product==='999'">{{ copyService.copies.agreement_filter_title }}</h1>
    <p class="sub-title" *ngIf="code_product==='999'">{{ copyService.copies.agreement_filter_sub_title }}</p>
    <div class="search-pad">
        <vcl-internal-search [placeholder]="copyService.copies.agreement_filter_placeholder"
        [focus]="copyService.copies.agreement_filter_placeholder" 
        [(stringSearch)]="stringSearch"
        (stringSearchChange)="onChangeSearch($event)">
        </vcl-internal-search>
    </div>
    <div class="row" *ngIf="stringSearch.length > 2">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="box-input">
                <voxel-form-field [id]="'input-value-city'" [label]="copyService.copies.agreement_filter_label" [formGroup]="formGroup">
                    <vcl-autocomplete id="autoCompleteComponent" [placeholder]="copyService.copies.agreement_filter_placeholder" (change)="selectOption($event)" required [notFoundMessage]="copyService.copies.agreement_filter_not_found_message" [notFoundTitle]="copyService.copies.agreement_filter_not_found_title">
                        <vcl-option [id]="'id'" *ngFor="let option of options | search : stringSearch" [value]="option" [selected]="option.description === selectedAgreement.description">
                            {{option.agreement_number ? option.agreement_number : option.agreement_id}} {{ option.description }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
        </div>
    </div>
    <div class="row box-detail mt-5" *ngIf="selectedAgreement.agreement_name!=''">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <p class="detail-agreement">
                {{ copyService.copies.agreement_filter_detail_title }}

            </p>
        </div>
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <p class="box-input">
                {{ copyService.copies.form_employee_company_placeholder }}
            </p>
            <p>
                {{selectedAgreement.client_name ? selectedAgreement.client_name : selectedAgreement.agreement_name}}
            </p>
        </div>

        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <p class="box-input">
                {{ copyService.copies.agreement_filter_nit }}
            </p>
            <p>
                {{selectedAgreement.client_nit  ? selectedAgreement.client_nit : selectedAgreement.agreement_id}}

            </p>
        </div>

        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <p class="box-input">
                {{ copyService.copies.agreement_filter_label }}
            </p>
            <p>
                {{selectedAgreement.agreement_name}}

            </p>
        </div>

        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <p class="box-input">
                {{ copyService.copies.agreement_filter_number_agreement }}
            </p>
            <p>
                {{selectedAgreement.agreement_number ? selectedAgreement.agreement_number : selectedAgreement.agreement_id}}

            </p>
        </div>
    </div>
</div>
<app-controls id="docIntroBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.agreement_filter_next_button" (next)="next()" [nextDisabled]="selectedAgreement.agreement_code === '0'"></app-controls>